
import { connect } from "react-redux";
import { compose } from 'redux'
import { withRouter } from 'react-router-dom';
import { createUser } from '../../actions'

import { reduxForm } from 'redux-form'
function mapStateToProps({ AuthReducer }) {
  
  let errorMensage = "";
  if (AuthReducer.signup && AuthReducer.signup.crudError) {
    if (AuthReducer.signup.crudError.message)
      errorMensage = AuthReducer.signup.crudError.message;
    else
      errorMensage = AuthReducer.signup.crudError;
  }
  return { errorMensage };
}


export default compose(
  withRouter,
  connect(mapStateToProps, { createUser }),
  reduxForm({
    form: 'SingUpForm',

  })

);


// WEBPACK FOOTER //
// ./src/routes/public/Login/components/SignUp/SignUp.enhancer.js